import React, { useRef, useEffect, memo } from "react";
import { useSignaturePad } from "../hooks/useSignaturePad";

const SignaturePad = ({
  canvasRef: externalRef,
  onSignatureChange,
  signaturePadRef = null,
  personnelSignaturePadRef = null,
  setHasSignature = null,
  setHasPersonnelSignature = null,
  width = 400,
  height = 150,
  className = "signature-pad",
  ...props
}) => {
  const internalRef = useRef(null);
  const canvasRef = externalRef || internalRef;

  const { handleStart, handleMove, handleEnd } = useSignaturePad(
    canvasRef,
    onSignatureChange,
    signaturePadRef,
    personnelSignaturePadRef,
    setHasSignature,
    setHasPersonnelSignature
  );

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const onTouchStart = (e) => handleStart(e, canvasRef);
    const onTouchMove = (e) => handleMove(e, canvasRef);
    const onTouchEnd = (e) => handleEnd(e, canvasRef);

    canvas.addEventListener("touchstart", onTouchStart, { passive: false });
    canvas.addEventListener("touchmove", onTouchMove, { passive: false });
    canvas.addEventListener("touchend", onTouchEnd, { passive: false });

    return () => {
      canvas.removeEventListener("touchstart", onTouchStart);
      canvas.removeEventListener("touchmove", onTouchMove);
      canvas.removeEventListener("touchend", onTouchEnd);
    };
  }, [canvasRef, handleStart, handleMove, handleEnd]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      width={width}
      height={height}
      onMouseDown={(e) => handleStart(e, canvasRef)}
      onMouseMove={(e) => handleMove(e, canvasRef)}
      onMouseUp={(e) => handleEnd(e, canvasRef)}
      {...props}
    />
  );
};

export default memo(SignaturePad);
